import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const token = localStorage.getItem("access_token");
  const userRole = localStorage.getItem("user_role") || "admin";
  const location = useLocation();
  const host = (window.location.hostname || "").toLowerCase();
  const reportHost = host.startsWith("report.");
  const notificationsHost = host.startsWith("notifications.");
  
  if (!token) {
    if (reportHost || notificationsHost) {
      return <Navigate to="/auth" replace />;
    }
    return <Navigate to="/login" replace />;
  }
  
  // If user is report_viewer, allow report/notifications routes + root (host decides page at "/").
  const reportViewerAllowedPaths = ["/", "/daily-report", "/notifications"];
  if (userRole === "report_viewer" && !reportViewerAllowedPaths.includes(location.pathname)) {
    if (notificationsHost) return <Navigate to="/" replace />;
    return <Navigate to="/daily-report" replace />;
  }
  
  // If route requires admin and user is not admin, redirect to daily-report or home
  if (requireAdmin && userRole !== "admin") {
    if (userRole === "report_viewer") {
      return <Navigate to="/daily-report" replace />;
    }
    return <Navigate to="/" replace />;
  }
  
  return children;
};

export default ProtectedRoute;


